export default "__VITE_ASSET__ca21ef03__"